import Bag from "./bag";
import {
  CheckoutEvents,
  OnDemandEvents,
  OnDemandEventsData,
  CheckoutEventsData,
} from "@glamcorner/gc-types/generated/ipcBusEvents";
import Bus from "../../core/Bus";

const sessionStorageKey = "gc-visitor-email";
const visitorEmailFieldSelector = ".js-visitor-email";
const defaultConfig = { delayAfterDomReady: 1000 };

let instance: Visitor;

export default class Visitor {
  private config: { delayAfterDomReady: number; underTest?: boolean };
  private bus: Bus;
  private callbacks: { email: any[] };
  private document: Document;
  private email?: string | null;

  // Referenced in Emarsys GTM tag
  public bag: Bag;

  static getInstance() {
    if (!instance) {
      instance = new Visitor(window.document, window.location.pathname, GlamCornerCore.bus);
    }
    return instance;
  }

  constructor(document: Document, locationPathname: string, bus: Bus, config = {}) {
    this.config = Object.assign({}, defaultConfig, config);
    this.bus = bus;
    this.callbacks = { email: [] };
    this.bag = new Bag(locationPathname);
    this.document = document;
    this.setEmailFromDom = this.setEmailFromDom.bind(this);
    this.installHandlers();
    this.installListeners();
  }

  destroy() {
    this.uninstallHandlers();
  }

  domReady() {
    const setEmailFromDom = this.setEmailFromDom;
    setTimeout(setEmailFromDom, this.config.delayAfterDomReady);
  }

  getEmail() {
    if (!this.email) {
      this.email = window.sessionStorage.getItem(sessionStorageKey);
    }
    return this.email || null;
  }

  setEmail(email: string | null) {
    if (email && email.trim() && Visitor.isValid(email)) {
      this.email = email;
      Visitor.storeEmailInSessionStorage(email);
    }
  }

  onEmail(callback: Function) {
    if (!callback) throw new Error("bad callback");
    this.callbacks["email"].push(callback);
  }

  private notifyEmail(email: string | null) {
    if (email && email.trim() && Visitor.isValid(email)) {
      this.callbacks["email"].forEach((cb) => cb(email));
    }
  }

  private installHandlers() {
    this.document.querySelector(visitorEmailFieldSelector)?.addEventListener("blur", this.setEmailFromDom);
    if (!this.config.underTest) {
      this.document.addEventListener("load", this.domReady);
    }
  }

  private uninstallHandlers() {
    this.document.querySelector(visitorEmailFieldSelector)?.removeEventListener("blur", this.setEmailFromDom);
  }

  private installListeners() {
    this.bus.on(
      OnDemandEvents.CheckoutProceededToPayment,
      {},
      (data: OnDemandEventsData.CheckoutProceededToPaymentData) => {
        this.setEmail(data.shippingAddressEmail);
      }
    );
    this.bus.on(CheckoutEvents.LoginSuccess, {}, (data: CheckoutEventsData.LoginSuccessData) => {
      this.setEmail(data.email);
    });
  }

  private static storeEmailInSessionStorage(email: string) {
    window.sessionStorage.setItem(sessionStorageKey, email);
  }

  private static isValid(email: string) {
    return email.indexOf("@") !== -1 && email.indexOf(".") !== -1;
  }

  private setEmailFromDom() {
    this.setEmail(document.querySelector(visitorEmailFieldSelector)?.value);
    this.notifyEmail(document.querySelector(visitorEmailFieldSelector)?.value);
  }
}
